import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "CCTV Camera",
        price: 150,
        disprice: 120,
        stock: 12,
        content: "Secure your home or office with our high-definition CCTV Camera. Designed to provide 24/7 surveillance and peace of mind, it's the smart choice for modern security.",
        description: "Our CCTV Camera features night vision, motion detection, and remote access via mobile app. With weatherproof housing and HD recording, it's perfect for both indoor and outdoor monitoring. Easy to install and user-friendly, it’s ideal for boosting your security with minimal hassle.",
        category: ["Security Devices", "Surveillance Equipment"],
        tags: ["security", "surveillance", "access"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Resolution", content: "1080p Full HD" },
            { id: 2, title: "Night Vision", content: "Up to 30 meters" },
            { id: 3, title: "Connectivity", content: "Wi-Fi & Wired" },
            { id: 4, title: "Mobile App", content: "iOS & Android Compatible" }
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "Mason Carter",
                date: "Mar 10, 2025",
                rating: 5,
                content: "Crystal clear footage and easy setup. Highly recommended for home security!"
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Sophia Bennett",
                date: "Mar 15, 2025",
                rating: 4.5,
                content: "Excellent quality and reliable alerts. I feel much safer now!"
            }
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Smart Lock",
        price: 180,
        disprice: 145,
        stock: 8,
        content: "Upgrade your door security with our intelligent Smart Lock. Keyless entry, mobile control, and strong encryption make it perfect for modern homes.",
        description: "This Smart Lock combines style with security, offering features like fingerprint access, code unlocking, and smartphone connectivity. It's compatible with most door types and integrates with smart home systems for added convenience. Crafted with high-grade materials for durability and protection against tampering.",
        category: ["Security Devices", "Locking Systems"],
        tags: ["locks", "smart", "access"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Access Methods", content: "Fingerprint, PIN, Mobile App" },
            { id: 2, title: "Battery Life", content: "Up to 12 Months" },
            { id: 3, title: "Connectivity", content: "Bluetooth & Wi-Fi" },
            { id: 4, title: "Installation", content: "Fits Most Standard Doors" }
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "Ethan Roberts",
                date: "Apr 2, 2025",
                rating: 5,
                content: "Installation was quick, and the app control is very convenient. Great quality."
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Lily Thompson",
                date: "Apr 6, 2025",
                rating: 4.5,
                content: "Love the fingerprint access feature. Feels very secure and easy to use!"
            }
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Alarm System",
        price: 220,
        disprice: 185,
        stock: 3,
        content: "Protect your home or office with our advanced Alarm System. Featuring motion sensors, sirens, and remote monitoring to keep you safe 24/7.",
        description: "Our Alarm System offers a comprehensive security solution with door/window sensors, motion detectors, loud alarms, and remote access via mobile app. It's easy to install and supports integration with smart home platforms. Ideal for deterring intrusions and ensuring peace of mind.",
        category: ["Security Devices", "Surveillance Equipment"],
        tags: ["security", "alarm", "access"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Includes", content: "Control Panel, Motion Sensors, Door Sensors, Siren" },
            { id: 2, title: "Power Source", content: "Battery & AC Power" },
            { id: 3, title: "Connectivity", content: "Wi-Fi & GSM" },
            { id: 4, title: "Mobile App", content: "iOS & Android Compatible" }
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "Mason Clark",
                date: "May 12, 2025",
                rating: 5,
                content: "Excellent system! Easy to set up and the alerts are immediate. Highly recommended."
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Chloe Rivera",
                date: "May 17, 2025",
                rating: 4.5,
                content: "Works great and makes me feel much more secure at night. Solid performance."
            }
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Key Chains",
        price: 10,
        disprice: 7,
        stock: 0,
        content: "Keep your keys organized with our stylish and durable Key Chains. Perfect for home, office, or car keys.",
        description: "Our Key Chains are crafted from high-quality metal and leather, offering both elegance and reliability. Available in various colors and designs, they’re lightweight, compact, and designed to withstand daily use. A simple yet essential accessory for everyday convenience.",
        category: ["Access Tools", "Locking Systems"],
        tags: ["key", "access", "tools"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Metal & Faux Leather" },
            { id: 2, title: "Design Options", content: "Classic, Modern, Logo Print" },
            { id: 3, title: "Weight", content: "Approx. 50g" },
            { id: 4, title: "Usage", content: "Key Organizer, Gift Item" }
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Liam Bennett",
                date: "Apr 10, 2025",
                rating: 5,
                content: "Well-made and stylish. I bought a few as gifts too—everyone loved them!"
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Isabella Hughes",
                date: "Apr 12, 2025",
                rating: 4.5,
                content: "Looks premium and keeps all my keys in place. Great value for money."
            }
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Mortise Locks",
        price: 75,
        disprice: 60,
        stock: 13,
        content: "Enhance your door security with our heavy-duty Mortise Locks. Built for strength, reliability, and smooth operation.",
        description: "Our Mortise Locks offer superior security with robust construction and a sleek finish. Designed for both residential and commercial doors, they feature a solid brass body, precision key mechanism, and anti-pick technology. Easy to install and compatible with most standard doors, these locks combine traditional locking systems with modern durability.",
        category: ["Locking Systems", "Security Devices"],
        tags: ["locks", "security", "access"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Solid Brass & Steel" },
            { id: 2, title: "Lock Type", content: "Keyed Entry Mortise Lock" },
            { id: 3, title: "Finish Options", content: "Silver, Antique Bronze, Black" },
            { id: 4, title: "Compatibility", content: "Wood & Metal Doors" }
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "Noah Foster",
                date: "May 3, 2025",
                rating: 5,
                content: "Sturdy and reliable lock. Installation was simple, and it feels very secure."
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Mia Sullivan",
                date: "May 6, 2025",
                rating: 4.5,
                content: "Solid craftsmanship. Looks good and works smoothly. Highly recommended."
            }
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Drills",
        price: 120,
        disprice: 95,
        stock: 8,
        content: "Power through any project with our high-performance Drills—built for precision, durability, and ease of use.",
        description: "Our Drills feature a powerful motor, variable speed control, and ergonomic grip for enhanced control and comfort. Ideal for both professionals and DIY enthusiasts, these drills handle wood, metal, and masonry with ease. Comes with multiple drill bits, a rechargeable battery, and a compact carrying case.",
        category: ["Power Tools", "Access Tools"],
        tags: ["tools", "drill", "key"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Power Source", content: "Rechargeable Battery" },
            { id: 2, title: "Speed Settings", content: "Variable (0-1500 RPM)" },
            { id: 3, title: "Included Accessories", content: "Drill Bits, Charger, Case" },
            { id: 4, title: "Weight", content: "1.8 kg" }
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Ethan Carter",
                date: "May 15, 2025",
                rating: 5,
                content: "Very powerful and easy to handle. Battery life is impressive. Great value!"
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Sophia Bennett",
                date: "May 20, 2025",
                rating: 4.5,
                content: "Compact, reliable, and works well for home repairs. Highly satisfied with the purchase."
            }
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Luggage Padlocks",
        price: 20,
        disprice: 15,
        stock: 4,
        content: "Secure your bags with our TSA-approved Luggage Padlocks—compact, durable, and travel-friendly.",
        description: "These Luggage Padlocks are designed to keep your belongings safe while traveling. Made from zinc alloy with a flexible steel shackle, they feature a 3-digit combination lock and TSA compliance for airport security checks. Lightweight and easy to use, perfect for suitcases, backpacks, and lockers.",
        category: ["Locking Systems", "Security Devices"],
        tags: ["padlock", "security", "key"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Zinc Alloy + Steel Shackle" },
            { id: 2, title: "Lock Type", content: "3-Digit Combination" },
            { id: 3, title: "TSA Approved", content: "Yes" },
            { id: 4, title: "Weight", content: "85 g" }
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Liam Foster",
                date: "Mar 10, 2025",
                rating: 5,
                content: "Super convenient for traveling. The TSA feature gives me peace of mind at airports."
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Emma Collins",
                date: "Mar 15, 2025",
                rating: 4.5,
                content: "Compact and secure! Used it on my trip abroad and it held up perfectly."
            }
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Padlocks",
        price: 15,
        disprice: 12,
        stock: 0,
        content: "Secure your property with our durable and reliable Padlocks, ideal for gates, lockers, and storage units.",
        description: "Our Padlocks are made from hardened steel with a weather-resistant coating, ensuring long-lasting security. Featuring a strong shackle and precision locking mechanism, they provide high resistance against tampering and corrosion. Perfect for indoor and outdoor use.",
        category: ["Locking Systems", "Security Devices"],
        tags: ["padlock", "locks", "security"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Hardened Steel" },
            { id: 2, title: "Shackle Diameter", content: "8 mm" },
            { id: 3, title: "Weather Resistant", content: "Yes" },
            { id: 4, title: "Lock Type", content: "Keyed" }
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Noah Bennett",
                date: "Apr 5, 2025",
                rating: 5,
                content: "Strong and reliable padlock. Works great for my outdoor storage shed."
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "Sophia Reed",
                date: "Apr 8, 2025",
                rating: 4.7,
                content: "Good quality and weather resistant, perfect for my garden gate."
            }
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Locksmith Hammer",
        price: 25,
        disprice: 20,
        stock: 14,
        content: "Precision-crafted locksmith hammer designed for professional lock installation and repair tasks.",
        description: "This locksmith hammer features a balanced steel head and ergonomic handle for comfortable, controlled strikes. Ideal for delicate lock work and general locksmithing, it offers durability and precision in every use. The hammer's design minimizes user fatigue while maximizing impact efficiency.",
        category: ["Access Tools", "Power Tools"],
        tags: ["tools", "key", "locks"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Hardened Steel & Rubber Handle" },
            { id: 2, title: "Weight", content: "400 grams" },
            { id: 3, title: "Handle Length", content: "12 inches" },
            { id: 4, title: "Use", content: "Lock Installation & Repair" }
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Liam Parker",
                date: "Mar 12, 2025",
                rating: 5,
                content: "Perfect hammer for locksmith work — solid and comfortable."
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "Emma Collins",
                date: "Mar 15, 2025",
                rating: 4.8,
                content: "Great tool, well balanced and durable."
            }
        ]
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Surveillance Camera",
        price: 120,
        disprice: 99,
        stock: 11,
        content: "High-definition surveillance camera designed for reliable home and business security monitoring.",
        description: "Our Surveillance Camera offers crystal-clear 1080p video recording with night vision and motion detection. It features weatherproof housing, easy installation, and remote access via mobile app, ensuring you can monitor your property anytime, anywhere. Ideal for enhancing security and peace of mind.",
        category: ["Surveillance Equipment", "Security Devices"],
        tags: ["surveillance", "security", "alarm"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: "Resolution", content: "1080p Full HD" },
            { id: 2, title: "Night Vision", content: "Up to 30 meters" },
            { id: 3, title: "Connectivity", content: "Wi-Fi & Ethernet" },
            { id: 4, title: "Weatherproof", content: "IP66 Rated" }
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "Sophia Reynolds",
                date: "Apr 2, 2025",
                rating: 5,
                content: "Crystal clear video and easy setup. Works great day and night."
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "James Foster",
                date: "Apr 5, 2025",
                rating: 4.7,
                content: "Reliable and solid camera for home security."
            }
        ]
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Intelligent Lock",
        price: 180,
        disprice: 150,
        stock: 15,
        content: "Advanced intelligent lock providing keyless entry and smart security features for modern homes.",
        description: "Our Intelligent Lock supports fingerprint recognition, PIN code entry, and remote control via smartphone app. Designed for convenience and enhanced safety, it offers tamper alerts and logs access history. Easy to install and compatible with most door types.",
        category: ["Security Devices", "Locking Systems"],
        tags: ["smart", "locks", "access"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { id: 1, title: "Access Methods", content: "Fingerprint, PIN, App" },
            { id: 2, title: "Battery Life", content: "Up to 12 months" },
            { id: 3, title: "Connectivity", content: "Bluetooth & Wi-Fi" },
            { id: 4, title: "Compatibility", content: "Most standard doors" }
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "Mia Carter",
                date: "Mar 10, 2025",
                rating: 5,
                content: "Super convenient and very secure. Love the app control feature!"
            },
            {
                id: 2,
                image: images.product11Review2,
                name: "Ethan Ross",
                date: "Mar 15, 2025",
                rating: 4.8,
                content: "Easy installation and excellent functionality."
            }
        ]
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: "Alarm System",
        price: 220,
        disprice: 190,
        stock: 12,
        content: "Comprehensive alarm system designed to protect your home with advanced sensors and alert notifications.",
        description: "Our Alarm System includes motion detectors, door/window sensors, and a loud siren to deter intruders. It connects seamlessly to your smartphone for real-time alerts and remote monitoring. Easy to install and ideal for both homes and small businesses.",
        category: ["Security Devices", "Surveillance Equipment"],
        tags: ["alarm", "security", "access"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { id: 1, title: "Sensors Included", content: "Motion, Door & Window" },
            { id: 2, title: "Alert Type", content: "Mobile Notifications & Siren" },
            { id: 3, title: "Power Source", content: "Battery & AC Adapter" },
            { id: 4, title: "Coverage Area", content: "Up to 2000 sq ft" }
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: "Sophia Lee",
                date: "Apr 2, 2025",
                rating: 5,
                content: "Very reliable alarm system with easy app control."
            },
            {
                id: 2,
                image: images.product12Review2,
                name: "Liam Johnson",
                date: "Apr 5, 2025",
                rating: 4.7,
                content: "Great sensors and loud siren. Makes me feel safer at home."
            }
        ]
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Key Holder",
        price: 25,
        disprice: 20,
        stock: 30,
        content: "Stylish and practical key holder to organize your keys and keep them easily accessible.",
        description: "Our Key Holder is made from durable materials with a sleek design that complements any décor. It can hold multiple keys securely and features easy wall mounting or tabletop placement options. Perfect for home or office use.",
        category: ["Access Tools", "Locking Systems"],
        tags: ["key", "access", "tools"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Metal & Wood" },
            { id: 2, title: "Capacity", content: "Up to 20 Keys" },
            { id: 3, title: "Mounting Type", content: "Wall Mount & Tabletop" },
            { id: 4, title: "Finish", content: "Matte Black & Natural Wood" }
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "Emma Carter",
                date: "Mar 12, 2025",
                rating: 4.8,
                content: "Keeps my keys organized and looks great in the hallway."
            },
            {
                id: 2,
                image: images.product13Review2,
                name: "Noah Williams",
                date: "Mar 15, 2025",
                rating: 4.5,
                content: "Simple, sturdy, and practical. Highly recommend."
            }
        ]
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Deadbolt Lock",
        price: 75,
        disprice: 65,
        stock: 15,
        content: "Enhance your home security with our heavy-duty Deadbolt Lock, designed for maximum protection and durability.",
        description: "This Deadbolt Lock features a solid steel bolt, resistant to picking and drilling attempts. Easy to install and compatible with most doors, it provides reliable security for residential and commercial properties. The finish is corrosion-resistant for long-lasting use.",
        category: ["Locking Systems", "Security Devices"],
        tags: ["locks", "security", "key"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Hardened Steel" },
            { id: 2, title: "Bolt Size", content: "1 Inch" },
            { id: 3, title: "Finish", content: "Matte Bronze" },
            { id: 4, title: "Installation", content: "Fits Standard Doors" }
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: "Liam Johnson",
                date: "Apr 5, 2025",
                rating: 5,
                content: "Solid and reliable lock. Makes me feel safe at home."
            },
            {
                id: 2,
                image: images.product14Review2,
                name: "Sophia Martinez",
                date: "Apr 10, 2025",
                rating: 4.7,
                content: "Easy to install and works perfectly. Highly recommended!"
            }
        ]
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Power Drill",
        price: 120,
        disprice: 100,
        stock: 20,
        content: "Boost your DIY projects with our versatile Power Drill, designed for efficiency and durability.",
        description: "This Power Drill features a high-torque motor, multiple speed settings, and a comfortable grip for precise control. Ideal for drilling into wood, metal, and masonry. Comes with a rechargeable battery and quick-charge capability for extended use.",
        category: ["Power Tools", "Access Tools"],
        tags: ["drill", "tools", "key"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: "Power Source", content: "Rechargeable Battery" },
            { id: 2, title: "Speed Settings", content: "Variable (0-1500 RPM)" },
            { id: 3, title: "Chuck Size", content: "13 mm" },
            { id: 4, title: "Weight", content: "1.5 kg" }
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "Ethan Parker",
                date: "Mar 12, 2025",
                rating: 5,
                content: "Powerful drill with excellent battery life. Perfect for home and professional use."
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "Mia Thompson",
                date: "Mar 20, 2025",
                rating: 4.8,
                content: "Lightweight and easy to handle, very satisfied with this purchase."
            }
        ]
    }
];

export default products;